module.exports = __webpack_public_path__ + "static/media/img-deliveroo.8b402fee.svg";